export const httpToHttps = (url: string): string => {
  if (!url) return '';
  if (url.startsWith('https://')) {
    return url;
  }
  return url.replace('http://', 'https://');
};
